import { ReactElement } from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import Chip from '@mui/material/Chip';
import { ReactComponent as FacebookIcon } from '../../../assets/images/facebook.svg';
import { SocialCustomerDto } from 'common/models/customer';

const useStyles = makeStyles((theme) => ({
    label: {
        color: theme.palette.text.secondary,
    },
    parentChip: {
        height: 'auto',
        padding: '4px 4px 4px 8px !important',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '30px',
        border: '0px !important',
        backgroundColor: '#DCDBDC !important',
        '& .MuiChip-label': {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '0',
        },
    },
    childChip: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        height: '20px',
        fontSize: '0.75rem',
        backgroundColor: '#1876D2 !important',
        color: '#FFFFFF !important',
        padding: '2px 8px !important',
        borderRadius: '30px',
    },
}));

export interface CustomerFacebookSectionProps {
    facebookAccounts: SocialCustomerDto[];
}

export function CustomerFacebookSection({
    facebookAccounts
}: CustomerFacebookSectionProps): ReactElement {
    const classes = useStyles();
    return (
        <Grid container spacing={1} justifyContent="space-between">
            <Grid item xs={12}>
                <Grid container alignItems="center" >
                    <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                        <FacebookIcon style={{ marginRight: '5px', width: '24px', height: '24px' }} />
                    </Grid>
                    <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h5" > Facebook</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body2" className={classes.label} component="div">
                    {facebookAccounts.length > 0 ? (
                        <Grid container spacing={1} direction="column">
                            {facebookAccounts.map((account) => (
                                <Grid item key={account.id}>
                                    <Chip
                                        className={classes.parentChip}
                                        label={
                                            <>
                                                {account.socialCustomerName}
                                                <Chip
                                                    className={classes.childChip}
                                                    label={'Name'}
                                                    size="small"
                                                />
                                            </>
                                        }
                                        variant="outlined"
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    ) : "—"}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerFacebookSection;
